import { ConvertTimeToUTC } from '../header/timeFormatter';

let transactionInterval = null;

const transaction = {
    transactionModel: {
        TransactionStartLocal: null,
        TransactionEndLocal: null,
        TransactionDuration: 1,
        WarningCount: 0,
        InactiveCount: 0
    },
    back: {
        pageName: null
    },
    getTime: function () {
        return ConvertTimeToUTC(new Date()).toString();
    },
    start: function () {
        transactionInterval = setInterval(function () {
            transaction.transactionModel.TransactionDuration++;
        }, 1000);
    },
    stop: function () {
        clearInterval(transactionInterval);
    },
    clear: function () {
        transaction.stop();
        transaction.transactionModel.TransactionStartLocal = null;
        transaction.transactionModel.TransactionEndLocal = null;
        transaction.transactionModel.TransactionDuration = 1;
        transaction.transactionModel.WarningCount = 0;
        transaction.back.pageName = null;
    }
};

function begin(pageName) {
    transaction.clear();
    transaction.back.pageName = pageName;
    transaction.transactionModel.TransactionStartLocal = transaction.getTime();
    transaction.start();
}

function end() {
    transaction.transactionModel.TransactionEndLocal = transaction.getTime();
    transaction.stop();
}

function cancel() {
    transaction.clear();
}

function keepRun() {
    transaction.start();
}

function updateData(obj) {
    if (!transaction.transactionModel.TransactionStartLocal) {
        obj.TransactionStartLocal = null;
        obj.TransactionEndLocal = null;
        obj.SessionDuration = null;
        obj.WarningCount = null;
    }
    else {
        obj.TransactionStartLocal = transaction.transactionModel.TransactionStartLocal;
        obj.TransactionEndLocal = transaction.transactionModel.TransactionEndLocal;
        obj.TransactionStart = transaction.transactionModel.TransactionStartLocal;
        obj.TransactionEnd = transaction.transactionModel.TransactionEndLocal;
        obj.SessionDuration = transaction.transactionModel.TransactionDuration;
        obj.WarningCount = transaction.transactionModel.WarningCount;
    }
}

function warning() {
    transaction.transactionModel.WarningCount++;
    transaction.stop();
}

export const TransactionTime = {
    begin,
    end,
    cancel,
    warning,
    keepRun,
    updateData
};
